import { ColProps } from "antd";
import { Option } from "../../../shared/interface";
import { DataForm, ValidationStatus } from "../components/types";

export const YnArray = [
  { id: 1, value: "네" },
  { id: 2, value: "아니오" },
];
export const availableAndIgnoranceArray: Option[] = [
  { label: "가능", value: true },
  { label: "불가능", value: false },
  {
    label: "모름",
    value: null,
  },
];

export const marketingPossibleArray: Option[] = [
  { label: "개인정보 수집 및 이용에 동의합니다", value: true },
];
export const holdingArray: Option[] = [
  { label: "보유", value: true },
  { label: "미보유", value: false },
];
export const availableArray: Option[] = [
  { label: "가능", value: true },
  { label: "불가능", value: false },
];
export const DayArray = [
  { id: 1, value: "월요일" },
  { id: 2, value: "화요일" },
  { id: 3, value: "수요일" },
  { id: 4, value: "목요일" },
  { id: 5, value: "금요일" },
  { id: 6, value: "토요일" },
  { id: 7, value: "일요일" },
];
export const HolidayArray = [
  { id: 1, value: "명절" },
  { id: 2, value: "그외 공휴일" },
  { id: 3, value: "대체 공휴일" },
];
export const TimeArray = () => {
  const array: { id: number; value: string }[] = [];
  for (let i = 0; i < 24; i += 1) {
    array.push({
      id: i,
      value:
        (i + 1).toString().length === 1
          ? `0${(i + 1).toString()}:00`
          : `${(i + 1).toString()}:00`,
    });
  }
  return array;
};
export const NumberArray = (value: number) => {
  const array: { id: number; value: string }[] = [];
  for (let i = 0; i < value; i += 1) {
    array.push({ id: i, value: (i + 1).toString() });
  }
  return array;
};
export const PLACEHOLDER = {
  aId: "아이디를 입력해주세요",
  pass: "비밀번호를 입력해주세요",
  rePass: "비밀번호를 한 번 더 입력해주세요",

  manageName: "담당자 성함을 입력해주세요",
  diplayName: "상호명을 입력해주세요",
  email: "이메일 주소를 입력해주세요",
  phone: "‘-’ 없이 숫자만 입력해주세요",
  name: "간판명과 상호가 다를 경우에 기재해주세요",
  businessRegistrationNumber: "사업자 등록번호를 입력해주세요",
  address: "주소찾기",
  detailAddress: "상세주소를 입력해주세요",
  file: "파일을 첨부해주세요",
  select: "선택",
  moreDetail:
    "다수 가맹점 보유 등 추가로 입력하고 싶은 사항이 있으면 입력해주세요.",
  introduction: "타이어픽 홈페이지에 반영될 소개글을 작성해주세요.",
};
export const colHalfProps: ColProps = {
  xs: 24,
  sm: 24,
  md: 24,
  lg: 12,
  xl: 12,
  xxl: 12,
};
export const colFullProps: ColProps = {
  span: 24,
};
export enum SpecialCar {
  BONGO,
  PORTER_LOW_TOP,
  PORTER_HIGH_TOP,
}

export enum CountryType {
  Domestic,
  Foreign,
}

export const specialCarArray: Option[] = [
  { label: "봉고", value: SpecialCar.BONGO },
  {
    label: "포터로우탑",
    value: SpecialCar.PORTER_LOW_TOP,
  },
  {
    label: "포터하이탑",
    value: SpecialCar.PORTER_HIGH_TOP,
  },
];
export const countryTypeArray: Option[] = [
  { label: "국산차", value: CountryType.Domestic },
  { label: "수입차", value: CountryType.Foreign },
];
export const initialValidation: ValidationStatus = {
  status: undefined,
  explain: undefined,
};
export const initialDataForm: DataForm = {
  repairShopAId: "",
  password: "",
  rePass: "",
  displayName: "",
  managerName: "",
  managerPhone: "",
  subPhone1: "",
  subPhone2: "",
  managerEmail: "",
  tel: "",
  repairShopName: "",
  regionDepth1: "",
  regionDepth2: "",
  regionDepth3: "",
  zipCode: 0,
  country: "",

  businessRegistrationNumber: undefined,
  businessMediaId: undefined,
  street: "",
  detail: "",
  zibun: "",
  liftCount: 5,
  activated: true,
  employeeCount: 5,
  foreignWAHandleable: true,
  domesticWAHandleable: true,
  allMedia: undefined,
  frontMedia: undefined,
  inMedia: undefined,
  rFTHandleable: true,

  foreignCarHandleable: true,
  waitingRoomExistence: true,
  twentyInchTireHandleable: true,
  moreDetail: undefined,
  introduction: undefined,
  repairShopMediaIds: [],
  marketingMessageReceivable: false,
  marketingEmailReceivable: false,
  marketingPushReceivable: false,
  domesticLightRepairHandleable: true,

  domesticEngineOilExchangeable: true,
  domesticBatteryExchangeable: true,
  foreignEngineOilExchangeable: true,
  foreignBatteryExchangeable: true,
  foreignLightRepairHandleable: true,
  maximumWeekdayVehicleCount: 0,
  maximumWeekendVehicleCount: 0,
  bongoAcceptable: true,
  porterHighTopAcceptable: true,
  porterLowTopAcceptable: true,

  subManagerPhoneList: [],
  repairShopMedias: [],
  truckAcceptable: true,
  optionalTermsIds: [],
  lightRepairTypes: [CountryType.Domestic, CountryType.Foreign],
  waTypes: [CountryType.Domestic, CountryType.Foreign],
  speciaCars: [
    SpecialCar.BONGO,
    SpecialCar.PORTER_LOW_TOP,
    SpecialCar.PORTER_HIGH_TOP,
  ],
  batteryTypes: [CountryType.Domestic, CountryType.Foreign],
  engineOilTypes: [CountryType.Domestic, CountryType.Foreign],
  authTokenId: "",
  accessToken: "",

  repairShopOption: undefined,
};
export const initialInputRef = {
  repairShopAId: null,
  password: null,
  rePass: null,
  displayName: null,
  managerName: null,
  managerPhone: null,
  subPhone1: null,
  subPhone2: null,
  managerEmail: null,
  tel: null,
  street: null,
  detail: null,
  businessRegistrationNumber: null,
  businessMediaId: null,
  repairShopMediaIds: null,
  waTypes: null,
  specialCars: null,
};
export const initialDivRef = {
  businessMediaId: null,
  repairShopMediaIds: null,
};
